import React from 'react'
import Start from '../../common/pages/Start.jsx'

const S1_Start = (props) => {
    return (
        <Start data={props}/>
    )
}

export default S1_Start

